var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _mask5, _path5, _mask6, _path6, _mask7, _path7, _mask8, _path8, _mask9, _path9, _mask10, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGandom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 599,
    height: 960,
    viewBox: "0 0 599 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.27 -72.9002C535.725 -72.1504 531.561 -70.4632 529.016 -69.1504C518.659 -63.8067 386.131 14.4109 380.015 18.7891C353.822 37.5393 332.062 67.1707 321.964 97.8362C314.727 119.814 314.853 118.425 314.405 180.65L314 237.033L317.405 234.94C319.278 233.79 358.288 211.036 404.093 184.375C542.496 103.819 532.456 109.978 547.247 96.5472C572.898 73.2539 588.778 44.9238 595.941 9.67794C597.908 -0.00462055 598.365 -5.46552 598.371 -19.3583C598.376 -34.4956 598.114 -37.1783 596.098 -42.6154C591.591 -54.7702 583.09 -64.0866 571.206 -69.8928C564.189 -73.3212 562.645 -73.6696 553.213 -73.9527C546.819 -74.1446 541.137 -73.7443 538.27 -72.9002Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.27 -72.9002C535.725 -72.1504 531.561 -70.4632 529.016 -69.1504C518.659 -63.8067 386.131 14.4109 380.015 18.7891C353.822 37.5393 332.062 67.1707 321.964 97.8362C314.727 119.814 314.853 118.425 314.405 180.65L314 237.033L317.405 234.94C319.278 233.79 358.288 211.036 404.093 184.375C542.496 103.819 532.456 109.978 547.247 96.5472C572.898 73.2539 588.778 44.9238 595.941 9.67794C597.908 -0.00462055 598.365 -5.46552 598.371 -19.3583C598.376 -34.4956 598.114 -37.1783 596.098 -42.6154C591.591 -54.7702 583.09 -64.0866 571.206 -69.8928C564.189 -73.3212 562.645 -73.6696 553.213 -73.9527C546.819 -74.1446 541.137 -73.7443 538.27 -72.9002Z",
    stroke: "url(#paint0_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-1-inside-1_362_63677)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.27 134.1C530.725 134.85 526.561 136.537 524.016 137.85C513.659 143.193 381.131 221.411 375.015 225.789C348.822 244.539 327.062 274.171 316.964 304.836C309.727 326.814 309.853 325.425 309.405 387.65L309 444.033L312.405 441.94C314.278 440.79 353.288 418.036 399.093 391.375C537.496 310.819 527.456 316.978 542.247 303.547C567.898 280.254 583.778 251.924 590.941 216.678C592.908 206.995 593.365 201.534 593.371 187.642C593.376 172.504 593.114 169.822 591.098 164.385C586.591 152.23 578.09 142.913 566.206 137.107C559.189 133.679 557.645 133.33 548.213 133.047C541.819 132.855 536.137 133.256 533.27 134.1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.27 134.1C530.725 134.85 526.561 136.537 524.016 137.85C513.659 143.193 381.131 221.411 375.015 225.789C348.822 244.539 327.062 274.171 316.964 304.836C309.727 326.814 309.853 325.425 309.405 387.65L309 444.033L312.405 441.94C314.278 440.79 353.288 418.036 399.093 391.375C537.496 310.819 527.456 316.978 542.247 303.547C567.898 280.254 583.778 251.924 590.941 216.678C592.908 206.995 593.365 201.534 593.371 187.642C593.376 172.504 593.114 169.822 591.098 164.385C586.591 152.23 578.09 142.913 566.206 137.107C559.189 133.679 557.645 133.33 548.213 133.047C541.819 132.855 536.137 133.256 533.27 134.1Z",
    stroke: "url(#paint1_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-2-inside-2_362_63677)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.27 341.1C525.725 341.85 521.561 343.537 519.016 344.85C508.659 350.193 376.131 428.411 370.015 432.789C343.822 451.539 322.062 481.171 311.964 511.836C304.727 533.814 304.853 532.425 304.405 594.65L304 651.033L307.405 648.94C309.278 647.79 348.288 625.036 394.093 598.375C532.496 517.819 522.456 523.978 537.247 510.547C562.898 487.254 578.778 458.924 585.941 423.678C587.908 413.995 588.365 408.534 588.371 394.642C588.376 379.504 588.114 376.822 586.098 371.385C581.591 359.23 573.09 349.913 561.206 344.107C554.189 340.679 552.645 340.33 543.213 340.047C536.819 339.855 531.137 340.256 528.27 341.1Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.27 341.1C525.725 341.85 521.561 343.537 519.016 344.85C508.659 350.193 376.131 428.411 370.015 432.789C343.822 451.539 322.062 481.171 311.964 511.836C304.727 533.814 304.853 532.425 304.405 594.65L304 651.033L307.405 648.94C309.278 647.79 348.288 625.036 394.093 598.375C532.496 517.819 522.456 523.978 537.247 510.547C562.898 487.254 578.778 458.924 585.941 423.678C587.908 413.995 588.365 408.534 588.371 394.642C588.376 379.504 588.114 376.822 586.098 371.385C581.591 359.23 573.09 349.913 561.206 344.107C554.189 340.679 552.645 340.33 543.213 340.047C536.819 339.855 531.137 340.256 528.27 341.1Z",
    stroke: "url(#paint2_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-3-inside-3_362_63677)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.27 548.1C520.725 548.85 516.561 550.537 514.016 551.85C503.659 557.193 371.131 635.411 365.015 639.789C338.822 658.539 317.062 688.171 306.964 718.836C299.727 740.814 299.853 739.425 299.405 801.65L299 858.033L302.405 855.94C304.278 854.79 343.288 832.036 389.093 805.375C527.496 724.819 517.456 730.978 532.247 717.547C557.898 694.254 573.778 665.924 580.941 630.678C582.908 620.995 583.365 615.534 583.371 601.642C583.376 586.504 583.114 583.822 581.098 578.385C576.591 566.23 568.09 556.913 556.206 551.107C549.189 547.679 547.645 547.33 538.213 547.047C531.819 546.855 526.137 547.256 523.27 548.1Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.27 548.1C520.725 548.85 516.561 550.537 514.016 551.85C503.659 557.193 371.131 635.411 365.015 639.789C338.822 658.539 317.062 688.171 306.964 718.836C299.727 740.814 299.853 739.425 299.405 801.65L299 858.033L302.405 855.94C304.278 854.79 343.288 832.036 389.093 805.375C527.496 724.819 517.456 730.978 532.247 717.547C557.898 694.254 573.778 665.924 580.941 630.678C582.908 620.995 583.365 615.534 583.371 601.642C583.376 586.504 583.114 583.822 581.098 578.385C576.591 566.23 568.09 556.913 556.206 551.107C549.189 547.679 547.645 547.33 538.213 547.047C531.819 546.855 526.137 547.256 523.27 548.1Z",
    stroke: "url(#paint3_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-4-inside-4_362_63677)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.27 755.1C515.725 755.85 511.561 757.537 509.016 758.85C498.659 764.193 366.131 842.411 360.015 846.789C333.822 865.539 312.062 895.171 301.964 925.836C294.727 947.814 294.853 946.425 294.405 1008.65L294 1065.03L297.405 1062.94C299.278 1061.79 338.288 1039.04 384.093 1012.37C522.496 931.819 512.456 937.978 527.247 924.547C552.898 901.254 568.778 872.924 575.941 837.678C577.908 827.995 578.365 822.534 578.371 808.642C578.376 793.504 578.114 790.822 576.098 785.385C571.591 773.23 563.09 763.913 551.206 758.107C544.189 754.679 542.645 754.33 533.213 754.047C526.819 753.855 521.137 754.256 518.27 755.1Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.27 755.1C515.725 755.85 511.561 757.537 509.016 758.85C498.659 764.193 366.131 842.411 360.015 846.789C333.822 865.539 312.062 895.171 301.964 925.836C294.727 947.814 294.853 946.425 294.405 1008.65L294 1065.03L297.405 1062.94C299.278 1061.79 338.288 1039.04 384.093 1012.37C522.496 931.819 512.456 937.978 527.247 924.547C552.898 901.254 568.778 872.924 575.941 837.678C577.908 827.995 578.365 822.534 578.371 808.642C578.376 793.504 578.114 790.822 576.098 785.385C571.591 773.23 563.09 763.913 551.206 758.107C544.189 754.679 542.645 754.33 533.213 754.047C526.819 753.855 521.137 754.256 518.27 755.1Z",
    stroke: "url(#paint4_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-5-inside-5_362_63677)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1009 -176.9C82.6456 -176.15 86.8096 -174.463 89.3543 -173.15C99.7111 -167.807 232.239 -89.5891 238.356 -85.2109C264.549 -66.4607 286.309 -36.8293 296.407 -6.16385C303.644 15.8135 303.517 14.425 303.966 76.6498L304.371 133.033L300.966 130.94C299.092 129.79 260.082 107.036 214.277 80.3748C75.875 -0.181206 85.9142 5.97753 71.1239 -7.45279C45.4731 -30.7461 29.593 -59.0762 22.4297 -94.3221C20.4628 -104.005 20.0052 -109.466 20.0001 -123.358C19.995 -138.496 20.2571 -141.178 22.2723 -146.615C26.7798 -158.77 35.2807 -168.087 47.1643 -173.893C54.1816 -177.321 55.7259 -177.67 65.1573 -177.953C71.5515 -178.145 77.2333 -177.744 80.1009 -176.9Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1009 -176.9C82.6456 -176.15 86.8096 -174.463 89.3543 -173.15C99.7111 -167.807 232.239 -89.5891 238.356 -85.2109C264.549 -66.4607 286.309 -36.8293 296.407 -6.16385C303.644 15.8135 303.517 14.425 303.966 76.6498L304.371 133.033L300.966 130.94C299.092 129.79 260.082 107.036 214.277 80.3748C75.875 -0.181206 85.9142 5.97753 71.1239 -7.45279C45.4731 -30.7461 29.593 -59.0762 22.4297 -94.3221C20.4628 -104.005 20.0052 -109.466 20.0001 -123.358C19.995 -138.496 20.2571 -141.178 22.2723 -146.615C26.7798 -158.77 35.2807 -168.087 47.1643 -173.893C54.1816 -177.321 55.7259 -177.67 65.1573 -177.953C71.5515 -178.145 77.2333 -177.744 80.1009 -176.9Z",
    stroke: "url(#paint5_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-6-inside-6_362_63677)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1009 30.0998C77.6456 30.8496 81.8096 32.5368 84.3543 33.8496C94.7111 39.1933 227.239 117.411 233.356 121.789C259.549 140.539 281.309 170.171 291.407 200.836C298.644 222.814 298.517 221.425 298.966 283.65L299.371 340.033L295.966 337.94C294.092 336.79 255.082 314.036 209.277 287.375C70.875 206.819 80.9142 212.978 66.1239 199.547C40.4731 176.254 24.593 147.924 17.4297 112.678C15.4628 102.995 15.0052 97.5345 15.0001 83.6417C14.995 68.5044 15.2571 65.8217 17.2723 60.3846C21.7798 48.2298 30.2807 38.9134 42.1643 33.1072C49.1816 29.6788 50.7259 29.3304 60.1573 29.0473C66.5515 28.8554 72.2333 29.2557 75.1009 30.0998Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1009 30.0998C77.6456 30.8496 81.8096 32.5368 84.3543 33.8496C94.7111 39.1933 227.239 117.411 233.356 121.789C259.549 140.539 281.309 170.171 291.407 200.836C298.644 222.814 298.517 221.425 298.966 283.65L299.371 340.033L295.966 337.94C294.092 336.79 255.082 314.036 209.277 287.375C70.875 206.819 80.9142 212.978 66.1239 199.547C40.4731 176.254 24.593 147.924 17.4297 112.678C15.4628 102.995 15.0052 97.5345 15.0001 83.6417C14.995 68.5044 15.2571 65.8217 17.2723 60.3846C21.7798 48.2298 30.2807 38.9134 42.1643 33.1072C49.1816 29.6788 50.7259 29.3304 60.1573 29.0473C66.5515 28.8554 72.2333 29.2557 75.1009 30.0998Z",
    stroke: "url(#paint6_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-7-inside-7_362_63677)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-8_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1009 237.1C72.6456 237.85 76.8096 239.537 79.3543 240.85C89.7111 246.193 222.239 324.411 228.356 328.789C254.549 347.539 276.309 377.171 286.407 407.836C293.644 429.814 293.517 428.425 293.966 490.65L294.371 547.033L290.966 544.94C289.092 543.79 250.082 521.036 204.277 494.375C65.875 413.819 75.9142 419.978 61.1239 406.547C35.4731 383.254 19.593 354.924 12.4297 319.678C10.4628 309.995 10.0052 304.534 10.0001 290.642C9.99495 275.504 10.2571 272.822 12.2723 267.385C16.7798 255.23 25.2807 245.913 37.1643 240.107C44.1816 236.679 45.7259 236.33 55.1573 236.047C61.5515 235.855 67.2333 236.256 70.1009 237.1Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1009 237.1C72.6456 237.85 76.8096 239.537 79.3543 240.85C89.7111 246.193 222.239 324.411 228.356 328.789C254.549 347.539 276.309 377.171 286.407 407.836C293.644 429.814 293.517 428.425 293.966 490.65L294.371 547.033L290.966 544.94C289.092 543.79 250.082 521.036 204.277 494.375C65.875 413.819 75.9142 419.978 61.1239 406.547C35.4731 383.254 19.593 354.924 12.4297 319.678C10.4628 309.995 10.0052 304.534 10.0001 290.642C9.99495 275.504 10.2571 272.822 12.2723 267.385C16.7798 255.23 25.2807 245.913 37.1643 240.107C44.1816 236.679 45.7259 236.33 55.1573 236.047C61.5515 235.855 67.2333 236.256 70.1009 237.1Z",
    stroke: "url(#paint7_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-8-inside-8_362_63677)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-9_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1009 444.1C67.6456 444.85 71.8096 446.537 74.3543 447.85C84.7111 453.193 217.239 531.411 223.356 535.789C249.549 554.539 271.309 584.171 281.407 614.836C288.644 636.814 288.517 635.425 288.966 697.65L289.371 754.033L285.966 751.94C284.092 750.79 245.082 728.036 199.277 701.375C60.875 620.819 70.9142 626.978 56.1239 613.547C30.4731 590.254 14.593 561.924 7.42972 526.678C5.46282 516.995 5.00523 511.534 5.00009 497.642C4.99495 482.504 5.25709 479.822 7.27231 474.385C11.7798 462.23 20.2807 452.913 32.1643 447.107C39.1816 443.679 40.7259 443.33 50.1573 443.047C56.5515 442.855 62.2333 443.256 65.1009 444.1Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1009 444.1C67.6456 444.85 71.8096 446.537 74.3543 447.85C84.7111 453.193 217.239 531.411 223.356 535.789C249.549 554.539 271.309 584.171 281.407 614.836C288.644 636.814 288.517 635.425 288.966 697.65L289.371 754.033L285.966 751.94C284.092 750.79 245.082 728.036 199.277 701.375C60.875 620.819 70.9142 626.978 56.1239 613.547C30.4731 590.254 14.593 561.924 7.42972 526.678C5.46282 516.995 5.00523 511.534 5.00009 497.642C4.99495 482.504 5.25709 479.822 7.27231 474.385C11.7798 462.23 20.2807 452.913 32.1643 447.107C39.1816 443.679 40.7259 443.33 50.1573 443.047C56.5515 442.855 62.2333 443.256 65.1009 444.1Z",
    stroke: "url(#paint8_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-9-inside-9_362_63677)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-10_362_63677",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1009 651.1C62.6456 651.85 66.8096 653.537 69.3543 654.85C79.7111 660.193 212.239 738.411 218.356 742.789C244.549 761.539 266.309 791.171 276.407 821.836C283.644 843.814 283.517 842.425 283.966 904.65L284.371 961.033L280.966 958.94C279.092 957.79 240.082 935.036 194.277 908.375C55.875 827.819 65.9142 833.978 51.1239 820.547C25.4731 797.254 9.59299 768.924 2.42972 733.678C0.462825 723.995 0.00523241 718.534 9.15527e-05 704.642C-0.00504931 689.504 0.257091 686.822 2.27231 681.385C6.77981 669.23 15.2807 659.913 27.1643 654.107C34.1816 650.679 35.7259 650.33 45.1573 650.047C51.5515 649.855 57.2333 650.256 60.1009 651.1Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1009 651.1C62.6456 651.85 66.8096 653.537 69.3543 654.85C79.7111 660.193 212.239 738.411 218.356 742.789C244.549 761.539 266.309 791.171 276.407 821.836C283.644 843.814 283.517 842.425 283.966 904.65L284.371 961.033L280.966 958.94C279.092 957.79 240.082 935.036 194.277 908.375C55.875 827.819 65.9142 833.978 51.1239 820.547C25.4731 797.254 9.59299 768.924 2.42972 733.678C0.462825 723.995 0.00523241 718.534 9.15527e-05 704.642C-0.00504931 689.504 0.257091 686.822 2.27231 681.385C6.77981 669.23 15.2807 659.913 27.1643 654.107C34.1816 650.679 35.7259 650.33 45.1573 650.047C51.5515 649.855 57.2333 650.256 60.1009 651.1Z",
    stroke: "url(#paint9_linear_362_63677)",
    strokeOpacity: 0.23,
    strokeWidth: 8,
    mask: "url(#path-10-inside-10_362_63677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_362_63677",
    x1: 456.185,
    y1: -74,
    x2: 456.185,
    y2: 237.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_362_63677",
    x1: 451.185,
    y1: 133,
    x2: 451.185,
    y2: 444.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_362_63677",
    x1: 446.185,
    y1: 340,
    x2: 446.185,
    y2: 651.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_362_63677",
    x1: 441.185,
    y1: 547,
    x2: 441.185,
    y2: 858.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_362_63677",
    x1: 436.185,
    y1: 754,
    x2: 436.185,
    y2: 1065.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_362_63677",
    x1: 162.185,
    y1: -178,
    x2: 162.185,
    y2: 133.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_362_63677",
    x1: 157.185,
    y1: 29,
    x2: 157.185,
    y2: 340.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_362_63677",
    x1: 152.185,
    y1: 236,
    x2: 152.185,
    y2: 547.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_362_63677",
    x1: 147.185,
    y1: 443,
    x2: 147.185,
    y2: 754.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_362_63677",
    x1: 142.185,
    y1: 650,
    x2: 142.185,
    y2: 961.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGandom);
export default __webpack_public_path__ + "static/media/gandom.398ff6875cc77855e5a0a3360f600314.svg";
export { ForwardRef as ReactComponent };